import axios from 'axios';

const backendBaseUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:4000';

export const getVpnServerInfo = async (ip, port = 80) => {
    // console.log("backendBaseUrl_curlApi", backendBaseUrl)
    const url = `${backendBaseUrl}/proxy?ip=${ip}&port=${port}`;
    // console.log('url', url);
    try {
        const response = await axios.get(url, {
            headers: {
                'Cache-Control': 'no-cache',
            },
            // Additional options like timeout, if needed
            timeout: 10000,
            // Include credentials if necessary
            withCredentials: true,
        });
        // console.log('raw response data', response.data);
        // Assuming response.data is not a string, convert it to a string first
        const responseData = typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
        
        // Log the stringified data
        //  console.log('stringified response data', responseData);
        
        const serverInfo = JSON.parse(responseData);
        return serverInfo;
    } catch (error) {
        console.error('Error fetching data:', error.message);
        throw error;
    }
};

export const updateSubProtocal = async (id, ip, subproto) => {
    const url = `${backendBaseUrl}/proxy2?id=${id}&ip=${ip}&subproto=${subproto}`;
    try {
        const response = await axios.get(url, {
            headers: {
                'Cache-Control': 'no-cache',
            },
            // Additional options like timeout, if needed
            timeout: 10000,
            // Include credentials if necessary
            withCredentials: true,
        });
        // console.log('raw response data', response.data);
        // Assuming response.data is not a string, convert it to a string first
        const responseData = typeof response.data === 'string' ? response.data : JSON.stringify(response.data);
        
        // Log the stringified data
        // console.log('stringified response data', responseData);
        
        const serverInfo = JSON.parse(responseData);
        return serverInfo;
    } catch (error) {
        console.error('Error fetching data:', error.message);
        throw error;
    }
}